export default __webpack_public_path__ + "static/media/matilda_logo.e0395d69.png";